module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('br'), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "text-info"
  }, [_c('i', {
    staticClass: "fa fa-info"
  }), _vm._v(" Info")])]), _vm._v(" "), _c('table', {
    staticClass: "el-table"
  }, [(_vm.siteData.candidate) ? _c('tr', [_c('td', [_vm._v("Client:")]), _c('td', [_c('el-row', {
    attrs: {
      "type": "flex",
      "justify-center": ""
    }
  }, [_c('el-col', [_c('org-badge', {
    attrs: {
      "organisation": _vm.siteData.candidate
    }
  })], 1), _vm._v(" "), _c('el-col', [_c('contacts-popover', {
    attrs: {
      "row-data": _vm.siteData,
      "org-prop": "candidate"
    }
  })], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Status:")]), _c('td', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(this.siteStatus(_vm.siteData.status))
    }
  })])]), _vm._v(" "), (_vm.siteData.active || (_vm.siteData.dismantled && _vm.siteData.status == 'Dismantled')) ? _c('tr', {
    class: !_vm.siteData.dismantled ? 'text-success' : 'text-danger'
  }, [_c('td', [_vm._v(_vm._s(_vm.siteData.dismantled ? 'Dismantled:' : 'Active'))]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.formatDate(!_vm.siteData.dismantled ? _vm.siteData.active : _vm.siteData.dismantled)))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.handover) ? _c('tr', [_c('td', [_vm._v("Handover:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.siteData.handover)))]), _vm._v(" ("), _c('i', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.siteData.handover)))]), _vm._v(")")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Site ID:")]), _c('td', [_c('span', {
    staticClass: "text-black"
  }, [_vm._v(_vm._s(_vm.siteData.siteId))]), (_vm.siteData.telcoSiteId) ? _c('b', {
    staticClass: "text-primary"
  }, [_vm._v(" | " + _vm._s(_vm.siteData.telcoSiteId))]) : _vm._e()])]), _vm._v(" "), (_vm.siteData.structure && _vm.siteData.structure.name) ? _c('tr', [_c('td', [_vm._v("Structure:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.structure.name)), _c('span', [_vm._v(" | " + _vm._s(_vm.siteData.structure.height) + "m.")])])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.coverage && _vm.isTowerCo()) ? _c('tr', [_c('td', [_vm._v("Coverage:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.coverage))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.siteGroup && _vm.isTowerCo()) ? _c('tr', [_c('td', [_vm._v("Site Group:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.siteGroup))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.onAir) ? _c('tr', {
    staticClass: "text-primary"
  }, [_c('td', [_vm._v("On Air:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.siteData.onAir)))]), _vm._v(" ("), _c('i', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.siteData.onAir)))]), _vm._v(")")])]) : _vm._e()])])], 1), _vm._v(" "), (_vm.hasStats && (_vm.isTowerCo() || _vm.isTelco()) && !_vm.isCandidate(_vm.siteData.status)) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('br'), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "text-primary"
  }, [_c('i', {
    staticClass: "fa fa-chart-line"
  }), _vm._v(" Stats")])]), _vm._v(" "), _c('table', {
    staticClass: "el-table"
  }, [(_vm.isTowerCo() && _vm.canAccess('project|maintenance|finance|management') && _vm.siteData.stats.orgName) ? _c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" PM:")]), _c('td', [_c('org-badge', {
    attrs: {
      "short-name": _vm.siteData.stats.orgName,
      "color": _vm.siteData.stats.colourCode
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.sharers) ? _c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Telcos:")]), _c('td', [(_vm.isTowerCo() && _vm.canAccess('project|maintenance|finance|management')) ? _c('el-button', {
    attrs: {
      "type": "success",
      "size": "mini",
      "plain": "",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.menu('sharers')
      }
    }
  }, [_vm._v(_vm._s(_vm.siteData.stats.sharers))]) : _c('strong', [_vm._v(_vm._s(_vm.siteData.stats.sharers))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.terminatedSharers && _vm.isTowerCo()) ? _c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-user-slash"
  }), _vm._v(" Terminated:")]), _c('td', [(_vm.isTowerCo() && _vm.canAccess('project|maintenance|finance|management')) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini",
      "plain": "",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.menu('sharers')
      }
    }
  }, [_vm._v(_vm._s(_vm.siteData.stats.terminatedSharers))]) : _c('strong', [_vm._v(_vm._s(_vm.siteData.stats.terminatedSharers))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.tickets && (_vm.isTelco() || _vm.canAccess('project|maintenance|management'))) ? _c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-headset"
  }), _vm._v(" Tickets:")]), _c('td', [_c('el-button', {
    attrs: {
      "type": "warning",
      "size": "mini",
      "plain": "",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.menu('maint')
      }
    }
  }, [_vm._v(_vm._s(_vm.siteData.stats.tickets))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.assets) ? _c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-cogs"
  }), _vm._v(" Equipment:")]), _c('td', [_c('el-button', {
    attrs: {
      "type": "info",
      "size": "mini",
      "plain": "",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.menu('equip')
      }
    }
  }, [_vm._v(_vm._s(_vm.siteData.stats.assets))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.permits && _vm.isTowerCo() && _vm.canAccess('project|property|finance|admin|management')) ? _c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-clipboard"
  }), _vm._v(" Permits:")]), _c('td', [_c('el-button', {
    attrs: {
      "type": "info",
      "size": "mini",
      "plain": "",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.menu('permits')
      }
    }
  }, [_vm._v(_vm._s(_vm.siteData.stats.permits))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.actions && _vm.isTowerCo() && !_vm.isLandOnly(_vm.siteData.status) && _vm.canAccess('project|maintenace|finance|admin')) ? _c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-asterisk"
  }), _vm._v(" Actions:")]), _c('td', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "plain": "",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.menu('actions')
      }
    }
  }, [_vm._v(_vm._s(_vm.siteData.stats.actions))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.backhaul && (_vm.isTelco() || (_vm.canAccess('finance|mangement|maintenance|project')))) ? _c('tr', [_c('td', [_c('i', {
    staticClass: "fa fa-broadcast-tower"
  }), _vm._v(" Backhaul:")]), _c('td', [_c('el-button', {
    attrs: {
      "type": "info",
      "size": "mini",
      "plain": "",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.menu('backhaul')
      }
    }
  }, [_vm._v(_vm._s(_vm.siteData.stats.backhaul))])], 1)]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('br'), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "text-success"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Locality")])]), _vm._v(" "), _c('table', {
    staticClass: "el-table"
  }, [(_vm.siteData.latitude || _vm.siteData.longitude) ? _c('tr', [_c('td', [_vm._v("Geo:")]), _vm._v(" "), _c('td', [_c('span', [_vm._v("\n             lat: "), _c('strong', [_vm._v(_vm._s(_vm.siteData.latitude))]), _vm._v("\n             lng: "), _c('strong', [_vm._v(_vm._s(_vm.siteData.longitude))])])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.address) ? _c('tr', [_c('td', [_vm._v("Address:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.address))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.zone) ? _c('tr', [_c('td'), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.zone))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.subdistrict || _vm.siteData.district) ? _c('tr', [_c('td'), _c('td', [_c('i', [_vm._v(_vm._s(_vm.siteData.subdistrict))]), _vm._v(" "), (_vm.siteData.district) ? _c('i', [(_vm.siteData.subdistrict) ? _c('span', [_vm._v(",\n              ")]) : _vm._e(), _vm._v(_vm._s(_vm.siteData.district))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.siteData.state) ? _c('tr', [_c('td'), _c('td', [_vm._v(_vm._s(_vm.siteData.state))])]) : _vm._e(), _vm._v(" "), (_vm.siteData.region) ? _c('tr', [_c('td'), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.region))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.country) ? _c('tr', [_c('td'), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.country))])])]) : _vm._e()])])], 1)], 1), _vm._v(" "), (_vm.isTowerCo()) ? _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [(_vm.siteData.stats.assets > 0) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('br'), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "text-info"
  }, [_c('i', {
    staticClass: "fa fa-cogs"
  }), _vm._v(" Equipment")])]), _vm._v(" "), _c('table', {
    staticClass: "el-table"
  }, [(_vm.siteData.stats.assetMW) ? _c('tr', [_c('td', [_vm._v("MW:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.assetMW))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.assetRRU) ? _c('tr', [_c('td', [_vm._v("RRU:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.assetRRU))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.assetTX) ? _c('tr', [_c('td', [_vm._v("TX:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.assetTX))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.assetFibre) ? _c('tr', [_c('td', [_vm._v("Fibre:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.assetFibre))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.assetPanel) ? _c('tr', [_c('td', [_vm._v("Panel:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.assetPanel))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.assetAAUPanel) ? _c('tr', [_c('td', [_vm._v("AAU Panel:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.assetAAUPanel))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.assetRFPanel) ? _c('tr', [_c('td', [_vm._v("RF Panel:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.assetRFPanel))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.assetAAS) ? _c('tr', [_c('td', [_vm._v("AAS:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.assetAAS))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.assetGrid) ? _c('tr', [_c('td', [_vm._v("Grid:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.assetGrid))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.assetMeter) ? _c('tr', [_c('td', [_vm._v("Meter:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.assetMeter))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.assetOwnMeter) ? _c('tr', [_c('td', [_vm._v("Own Meter:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.assetOwnMeter))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.assetCables) ? _c('tr', [_c('td', [_vm._v("Cables:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.assetCables))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.assetCabin) ? _c('tr', [_c('td', [_vm._v("Cabin:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.assetCabin))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.assetOutdoor) ? _c('tr', [_c('td', [_vm._v("Outdoor:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.assetOutdoor))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.assetOthers) ? _c('tr', [_c('td', [_vm._v("Others:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.assetOthers))])])]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.services > 0) ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('br'), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "text-info"
  }, [_c('i', {
    staticClass: "fa fa-wifi"
  }), _vm._v(" Services (" + _vm._s(_vm.siteData.stats.services) + ")")])]), _vm._v(" "), _c('table', {
    staticClass: "el-table"
  }, [(_vm.siteData.stats.service5G) ? _c('tr', [_c('td', [_vm._v("5G:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.service5G))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.service4G) ? _c('tr', [_c('td', [_vm._v("4G:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.service4G))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.service3G) ? _c('tr', [_c('td', [_vm._v("3G:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.service3G))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.service2G) ? _c('tr', [_c('td', [_vm._v("2G:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.service2G))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.serviceCMDA) ? _c('tr', [_c('td', [_vm._v("CMDA:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.serviceCMDA))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.serviceHPSA) ? _c('tr', [_c('td', [_vm._v("HPSA:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.serviceHPSA))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.serviceFDD) ? _c('tr', [_c('td', [_vm._v("FDD:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.serviceFDD))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.serviceLTE) ? _c('tr', [_c('td', [_vm._v("LTE:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.serviceLTE))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.serviceTDD) ? _c('tr', [_c('td', [_vm._v("TDD:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.serviceTDD))])])]) : _vm._e(), _vm._v(" "), (_vm.siteData.stats.serviceUMTS) ? _c('tr', [_c('td', [_vm._v("UMTS:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.siteData.stats.serviceUMTS))])])]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), (_vm.siteData.status != 'Sold' && _vm.siteData.status != 'Dismantled') ? _c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 8
    }
  }, [_c('br'), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "text-info"
  }, [_c('i', {
    staticClass: "fa fa-qrcode"
  }), _vm._v(" QR Code")])]), _vm._v(" "), (_vm.qrCode && _vm.isTowerCo()) ? _c('qr-code', {
    attrs: {
      "text": _vm.qrCode,
      "color": _vm.xolasClient().colourCode,
      "label": _vm.siteData.siteId,
      "file-name": _vm.siteData.siteId,
      "bw-background": true
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isCandidate(_vm.siteData.status)) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('site-attachments', {
    attrs: {
      "row-data": _vm.rowData
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-922f4b7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/SiteInfo.vue
// module id = 1673
// module chunks = 0